import React from 'react'

const AccountDetails = () => {
    return (
        <div className='rounded-midxs px-5 py-8 bg-smoke-100 lg:mb-32'>
            <div className='flex items-center'>
                <svg width='30' height='30' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path
                        opacity='0.3'
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M8.125 20H9.375C10.4105 20 11.25 20.8395 11.25 21.875V24.375C11.25 25.4105 10.4105 26.25 9.375 26.25H8.125C7.08947 26.25 6.25 25.4105 6.25 24.375V21.875C6.25 20.8395 7.08947 20 8.125 20ZM20.625 20H21.875C22.9105 20 23.75 20.8395 23.75 21.875V24.375C23.75 25.4105 22.9105 26.25 21.875 26.25H20.625C19.5895 26.25 18.75 25.4105 18.75 24.375V21.875C18.75 20.8395 19.5895 20 20.625 20Z'
                        fill='#52BD95'
                    />
                    <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M6.25 5H23.75C25.1307 5 26.25 6.11929 26.25 7.5V21.25C26.25 22.6307 25.1307 23.75 23.75 23.75H6.25C4.86929 23.75 3.75 22.6307 3.75 21.25V7.5C3.75 6.11929 4.86929 5 6.25 5ZM19.375 18.75C21.7912 18.75 23.75 16.7912 23.75 14.375C23.75 11.9588 21.7912 10 19.375 10C16.9588 10 15 11.9588 15 14.375C15 16.7912 16.9588 18.75 19.375 18.75ZM19.375 16.25C20.4105 16.25 21.25 15.4105 21.25 14.375C21.25 13.3395 20.4105 12.5 19.375 12.5C18.3395 12.5 17.5 13.3395 17.5 14.375C17.5 15.4105 18.3395 16.25 19.375 16.25ZM8.75 10C9.44036 10 10 10.5596 10 11.25V13.75C10 14.4404 9.44036 15 8.75 15C8.05964 15 7.5 14.4404 7.5 13.75V11.25C7.5 10.5596 8.05964 10 8.75 10Z'
                        fill='#52BD95'
                    />
                </svg>
                <p className='ml-2 tracking-wide text-dark font-medium text-lg'>Account information</p>
            </div>

            <div className='flex items-start mt-6'>
                <div>
                    <p className='text-xs text-dark opacity-75 tracking-wide'>Account number</p>
                    <p className='pt-1 font-medium text-dark tracking-wide'>9094581335</p>
                </div>
                <div className='ml-8'>
                    <p className='text-xs text-dark opacity-75 tracking-wide'>Name of account</p>
                    <p className='pt-1 font-medium text-dark tracking-wide'>Wood System LTD</p>
                </div>
            </div>
            <div className='mt-10'>
                <button className='w-full py-4 text-dark border border-smoke-300 rounded-xs'>
                    Copy account details
                </button>
            </div>
        </div>
    )
}

export default AccountDetails
